// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class CountryCache {
    constructor() {
        this.CachedImages = {};
        this.flagsSprite = '';
        this.flagOnCanvasWidth = 20;
        this.flagOnCanvasHeight = 15;
        this.flagLoadPromise = null;
        this.GetFlagImage = (id) => this.CachedImages[id.toString()];
        this.fetchFlagIfNotAlready = (ID) => __awaiter(this, void 0, void 0, function* () {
            const id = ID.toString();
            if (this.CachedImages[id] != null)
                return;
            const abrv = CountryCache.CountryFlagMap[id];
            if (abrv == null)
                return;
            const img = new Image();
            this.CachedImages[id] = img;
            if (isNullOrUndefined(this.flagLoadPromise) && this.flagsSprite.length === 0) {
                this.flagLoadPromise = fetch('assets/flags-sprite.svg').then((response) => __awaiter(this, void 0, void 0, function* () {
                    this.flagsSprite = yield response.text();
                    this.flagLoadPromise = null;
                }));
            }
            if (this.flagLoadPromise != null) {
                yield this.flagLoadPromise;
            }
            const srcStr = this.flagsSprite;
            if (srcStr == null || srcStr.length === 0)
                return;
            const iconElement = new DOMParser().parseFromString(srcStr, 'image/svg+xml');
            const svgElement = iconElement.getElementById(abrv);
            if (svgElement == null)
                return; // flag not found
            const originalWidth = parseFloat(svgElement.getAttribute('width'));
            const originalHeight = parseFloat(svgElement.getAttribute('height'));
            const viewBox = svgElement.getAttribute('viewBox');
            const widthScaleFactor = this.flagOnCanvasWidth / originalWidth;
            const heightScaleFactor = this.flagOnCanvasHeight / originalHeight;
            if (viewBox != null) {
                svgElement.setAttribute('width', this.flagOnCanvasWidth.toString());
                svgElement.setAttribute('height', this.flagOnCanvasHeight.toString());
            }
            else {
                svgElement.setAttribute('width', (originalWidth * widthScaleFactor).toString());
                svgElement.setAttribute('height', (originalHeight * heightScaleFactor).toString());
            }
            const updatedViewBox = viewBox !== null && viewBox !== void 0 ? viewBox : `0 0 ${originalWidth} ${originalHeight}`;
            svgElement.setAttribute('viewBox', updatedViewBox);
            const rectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
            rectElement.setAttribute('width', '640');
            rectElement.setAttribute('height', '470');
            rectElement.setAttribute('rx', '32');
            rectElement.setAttribute('ry', '32');
            rectElement.setAttribute('fill', 'white');
            const clipPath = svgElement.querySelector('clipPath');
            if (clipPath != null) {
                clipPath.firstChild.remove();
                clipPath.appendChild(rectElement);
            }
            const svgString = new XMLSerializer().serializeToString(svgElement).replace(/symbol/g, 'svg');
            const dataUri = `data:image/svg+xml,${encodeURIComponent(svgString)}`;
            img.src = dataUri;
        });
    }
}
CountryCache.CountryFlagMap = {
    1: 'af',
    2: 'al',
    3: 'dz',
    4: 'as',
    5: 'ad',
    6: 'ao',
    7: 'ai',
    8: 'aq',
    9: 'ag',
    10: 'ar',
    11: 'am',
    12: 'aw',
    13: 'au',
    14: 'at',
    15: 'az',
    16: 'bs',
    17: 'bh',
    18: 'bd',
    19: 'bb',
    20: 'by',
    21: 'be',
    22: 'bz',
    23: 'bj',
    24: 'bm',
    25: 'bt',
    26: 'bo',
    27: 'ba',
    28: 'bw',
    29: 'bv',
    30: 'br',
    31: 'io',
    32: 'bn',
    33: 'bg',
    34: 'bf',
    35: 'bi',
    36: 'kh',
    37: 'cm',
    38: 'ca',
    39: 'cv',
    40: 'ky',
    41: 'cf',
    42: 'td',
    43: 'cl',
    44: 'cn',
    45: 'cx',
    46: 'cc',
    47: 'co',
    48: 'km',
    49: 'cg',
    50: 'cd',
    51: 'zr',
    52: 'ck',
    53: 'cr',
    54: 'ci',
    55: 'hr',
    56: 'cu',
    57: 'cy',
    58: 'cz',
    59: 'dk',
    60: 'dj',
    61: 'dm',
    62: 'do',
    63: 'tp',
    64: 'ec',
    65: 'eg',
    66: 'sv',
    67: 'gq',
    68: 'er',
    69: 'ee',
    70: 'et',
    71: 'fk',
    72: 'fo',
    73: 'fj',
    74: 'fi',
    75: 'fr',
    76: 'fx',
    77: 'gf',
    78: 'pf',
    79: 'tf',
    80: 'ga',
    81: 'gm',
    82: 'ge',
    83: 'de',
    84: 'gh',
    85: 'gi',
    86: 'gr',
    87: 'gl',
    88: 'gd',
    89: 'gp',
    90: 'gu',
    91: 'gt',
    92: 'gn',
    93: 'gw',
    94: 'gy',
    95: 'ht',
    96: 'hm',
    97: 'hn',
    98: 'hk',
    99: 'hu',
    100: 'is',
    101: 'in',
    102: 'id',
    103: 'ir',
    104: 'iq',
    105: 'ie',
    106: 'il',
    107: 'it',
    108: 'jm',
    109: 'jp',
    110: 'jo',
    111: 'kz',
    112: 'ke',
    113: 'ki',
    114: 'kp',
    115: 'kr',
    116: 'kw',
    117: 'kg',
    118: 'la',
    119: 'lv',
    120: 'lb',
    121: 'ls',
    122: 'lr',
    123: 'ly',
    124: 'li',
    125: 'lt',
    126: 'lu',
    127: 'mo',
    128: 'mk',
    129: 'mg',
    130: 'mw',
    131: 'my',
    132: 'mv',
    133: 'ml',
    134: 'mt',
    135: 'mh',
    136: 'mq',
    137: 'mr',
    138: 'mu',
    139: 'yt',
    140: 'mx',
    141: 'fm',
    142: 'md',
    143: 'mc',
    144: 'mn',
    145: 'ms',
    146: 'ma',
    147: 'mz',
    148: 'mm',
    149: 'na',
    150: 'nr',
    151: 'np',
    152: 'nl',
    153: 'an',
    154: 'nc',
    155: 'nz',
    156: 'ni',
    157: 'ne',
    158: 'ng',
    159: 'nu',
    160: 'nf',
    161: 'mp',
    162: 'no',
    163: 'om',
    164: 'pk',
    165: 'pw',
    166: 'pa',
    167: 'pg',
    168: 'py',
    169: 'pe',
    170: 'ph',
    171: 'pn',
    172: 'pl',
    173: 'pt',
    174: 'pr',
    175: 'qa',
    176: 're',
    177: 'ro',
    178: 'ru',
    179: 'rw',
    180: 'sh',
    181: 'kn',
    182: 'lc',
    183: 'pm',
    184: 'vc',
    185: 'ws',
    186: 'sm',
    187: 'st',
    188: 'sa',
    189: 'sn',
    190: 'sc',
    191: 'sl',
    192: 'sg',
    193: 'sk',
    194: 'si',
    195: 'sb',
    196: 'so',
    197: 'za',
    198: 'gs',
    199: 'es',
    200: 'lk',
    201: 'sd',
    202: 'sr',
    203: 'sj',
    204: 'sz',
    205: 'se',
    206: 'ch',
    207: 'sy',
    208: 'tw',
    209: 'tj',
    210: 'tz',
    211: 'th',
    212: 'tg',
    213: 'tk',
    214: 'to',
    215: 'tt',
    216: 'tn',
    217: 'tr',
    218: 'tm',
    219: 'tc',
    220: 'tv',
    221: 'ug',
    222: 'ua',
    223: 'ae',
    224: 'gb',
    225: 'us',
    226: 'um',
    227: 'uy',
    228: 'uz',
    229: 'vu',
    230: 'va',
    231: 've',
    232: 'vn',
    233: 'vg',
    234: 'vi',
    235: 'wf',
    236: 'eh',
    237: 'ye',
    238: 'yu',
    239: 'zm',
    240: 'zw',
    241: 'me',
    242: 'gs',
    243: 'tl',
    244: 'kr',
    245: 'ax',
    246: 'gg',
    247: 'je',
    248: 'im',
    249: 'ps',
    250: 'rs',
    251: 'bq',
    252: 'bl',
    253: 'cw',
    254: 'mf',
    255: 'ss',
    256: 'sx',
    257: 'eu'
};
